import React, { ReactNode } from "react";
import { useForm } from "@inertiajs/react";
import { router } from "@inertiajs/react";
import { new_session_path, passwords_path } from "@/routes";
import { Box, Flex, Heading, VStack, Input, Button, Text } from "@chakra-ui/react";
import { Field } from "@/components/ui/field";
import DefaultLayout from "@/components/layouts/DefaultLayout";

const New = () => {
  const { data, setData, post, processing } = useForm({
    email: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post(passwords_path());
  };

  return (
    <Flex minH="100vh" alignItems="center" justifyContent="center" bg="gray.50">
      <Box maxW="md" w="full">
        <VStack gap={8}>
          <Box>
            <Heading as="h2" size="2xl" textAlign="center" color="gray.900" mt={6}>
              Reset your password
            </Heading>
            <Text mt={2} textAlign="center" fontSize="sm" color="gray.600">
              Enter your email address and we&apos;ll send you a link to reset your password.
            </Text>
          </Box>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <VStack gap={6} w="full">
              <Field label="Email address" srOnly htmlFor="email">
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="Email address"
                  value={data.email}
                  onChange={(e) => setData("email", e.target.value)}
                />
              </Field>

              <Button
                type="submit"
                disabled={processing}
                w="full"
                bg="primary-base"
                color="on-primary-base"
                _hover={{ bg: "primary-hover" }}
                cursor="pointer"
              >
                {processing ? "Sending..." : "Send reset instructions"}
              </Button>

              <Box textAlign="center">
                <Button
                  variant="plain"
                  type="button"
                  onClick={() => router.visit(new_session_path())}
                  color="primary-base"
                  _hover={{ color: "primary-hover" }}
                  fontSize="sm"
                >
                  Back to sign in
                </Button>
              </Box>
            </VStack>
          </form>
        </VStack>
      </Box>
    </Flex>
  );
};

New.layout = (page: ReactNode) => <DefaultLayout>{page}</DefaultLayout>;

export default New;
